// reactSelectStyles.js

export const tailwindSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '42px',
    borderRadius: '0.5rem', // rounded-lg
    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db', // blue-500 : gray-300
    boxShadow: state.isFocused ? '0 0 0 2px rgba(59,130,246,0.3)' : 'none',
    '&:hover': {
      borderColor: '#3b82f6',
    },
    paddingLeft: '2px',
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
  }),

  placeholder: (provided) => ({
    ...provided,
    color: '#9ca3af', // gray-400
  }),

  singleValue: (provided) => ({
    ...provided,
    color: '#111827', // gray-900
  }),

  menu: (provided) => ({
    ...provided,
    borderRadius: '0.5rem',
    overflow: 'hidden',
    zIndex: 50,
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#3b82f6' // blue-500
      : state.isFocused
      ? '#eff6ff' // blue-50
      : 'white',
    color: state.isSelected ? 'white' : '#111827',
    padding: '10px 12px',
    cursor: 'pointer',
  }),

  clearIndicator: (provided) => ({
    ...provided,
    cursor: 'pointer',
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    cursor: 'pointer',
  }),
};

